import { render, staticRenderFns } from "./OrderPurchaseInfo.vue?vue&type=template&id=438f0ce1&"
import script from "./OrderPurchaseInfo.vue?vue&type=script&lang=js&"
export * from "./OrderPurchaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports